import Clear from './../layouts/Clear.vue';

export default {
  path: '/clients',
  component: Clear,
  children: [
    {
      path: '',
      name: 'clients.index',
      component: () => import('@/views/clients/index.vue'),
    },
  ],
};
